import { render, staticRenderFns } from "./Emote.vue?vue&type=template&id=33ee0e49&scoped=true&"
import script from "./Emote.vue?vue&type=script&lang=js&"
export * from "./Emote.vue?vue&type=script&lang=js&"
import style0 from "./Emote.vue?vue&type=style&index=0&id=33ee0e49&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ee0e49",
  null
  
)

component.options.__file = "Emote.vue"
export default component.exports